import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ChevronUpIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ChevronUpIcon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/chevron/up">
            <path fill="none" d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </SvgIcon>
)
